import React, { useEffect, useState } from 'react';
import { useTitle } from '../Hooks';
import { UserBusiness } from '../Classes';
import { Button, Header, Message } from 'react-frontier';
import { bindClick } from '@tempu/components/Util';
import { BusinessItem, Modal } from '../components';
import { Link } from 'react-router-dom';
import API from '../API';

var BusinessList = ()=>{
	var { setTitle, setAction } = useTitle();
	var [loadError, setLoadError] = useState<string>(null);
	var [businessList, setBusinessList] = useState<UserBusiness[]>(null);
	var [businessModal, setBusinessModal] = useState<boolean>(false);
	
	useEffect(()=>{
		setTitle('Mis negocios');
		API.getUserBusiness().then(res=>{
			if(res.error) return setLoadError(res.message);
			setBusinessList(res.data);
		}).catch(err=>{

		})
		if(businessList?.length != 0){
			setAction(
				<Button text='Nuevo empleo' iconName='plus-circle' color='black' onClick={bindClick(setBusinessModal, true)} />
			);
		}	
	}, []);

	return <div className="tp business-list-screen">
		{loadError ? (
			<Header text='Error' subtext={loadError} />
		) : businessList ? (
			businessList.map(a=>(
				<BusinessItem key={`BSNLST-${a.business_id}`} business={a} to={`/business/${a.business_id}`} />
			))
		) : (new Array(5).fill('TEMPU')).map((a,i)=>(
			<BusinessItem placeholder key={`BSNPLH-${i}`} />
		))}
		{businessList?.length === 0 && <Message text='No cuentas con negocios.' centered style={{ fontWeight: 'bold', marginTop: 15 }} />}
		<Modal open={businessModal} onClose={bindClick(setBusinessModal)} size='tiny'>
			<Modal.Header>Nuevo empleo</Modal.Header>
			<Modal.Content>
				<Header text='Selecciona el negocio' subtext='Selecciona el negocio del nuevo empleo' />
				{businessList && businessList.length>0 ? businessList.map(a=>(
					<Link to={`/business/${a.business_id}/postings?create=1`}>
						<BusinessItem small business={a} key={`BSNMDL-${a.business_id}`}/>
					</Link>
				)) : (
					<Message text='No tienes negocios asignados' centered style={{ fontWeight: 'bold', marginTop: 15 }} />
				)}
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cerrar' onClick={bindClick(setBusinessModal)} />
			</Modal.Actions>
		</Modal>
	</div>
}

export default BusinessList;